import axios from 'axios';
import { getAuthHeaders, toQueryString } from '../../utils/utils';

export async function fetchAllPagination(filters = {}) {
  try {
    let url = `${window.config.API_URL_USER}notifications`;

    if (Object.keys(filters).length) {
      url = `${url}?${toQueryString(filters)}`;
    }

    const res = await axios.get(url, {
      //   headers: getAuthHeaders(getState()),
    });

    if (res.status === 201) {
      return res.data.data;
    }

    return [];
  } catch (err) {
    console.log('Error get clientes', err);
    throw new Error('no ok');
    // return [];
  }
}
export async function fetchAll(filters = {}) {
  try {
    let url = `${window.config.API_URL_USER}notifications/all`;

    if (Object.keys(filters).length) {
      url = `${url}?${toQueryString(filters)}`;
    }

    const res = await axios.get(url, {
      //   headers: getAuthHeaders(getState()),
    });
    console.log(res);

    if (res.status === 201) {
      return res.data.data;
    }

    return [];
  } catch (err) {
    console.log('Error get clientes', err);
    throw new Error('no ok');
    // return [];
  }
}

export async function fetchCurrentClient(cliRut) {
  try {
    const url = `${window.config.API_URL_USER}clientes/${cliRut}`;

    // if (Object.keys(filters).length) {
    //   url = `${url}?${toQueryString(filters)}`;
    // }

    const res = await axios.get(url, {
      //   headers: getAuthHeaders(getState()),
    });

    if (res.status === 201) {
      return res.data.data;
    }

    return [];
  } catch (err) {
    console.log('Error get faenas', err);
    throw new Error();
  }
}

export async function createData(data) {
  try {
    const url = `${window.config.API_URL_USER}notifications`;

    // if (Object.keys(filters).length) {
    //   url = `${url}?${toQueryString(filters)}`;
    // }

    const res = await axios.post(url, data, {
      //   headers: getAuthHeaders(getState()),
    });

    if (res.status === 201) {
      return res.data.data;
    }

    return [];
  } catch (err) {
    console.log('Error create client', err);
    throw new Error();
  }
}

export async function updateData(id, data) {
  try {
    const url = `${window.config.API_URL_USER}notifications/${id}`;

    const res = await axios.put(url, data, {
      //   headers: getAuthHeaders(getState()),
    });

    if (res.status === 201) {
      return res.data.data;
    }

    throw res.data.data?.message;
  } catch (error) {
    throw error;
  }
}
